import React, {Component} from 'react';
import axios from '../../axios';
import { axiosWC } from '../../axios';
import '../stylesheets/headerStyles.css'
import { withRouter } from 'react-router-dom';
import TestimonialsModal from './testimonialsModal';
import Loader from '../../Shared Components/loader';
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction"

class ReviewsComponent extends Component {
    constructor(props) {
        super(props);
        this.state  = {
            comments : [],
            totalReviews: 0,
            hasMoreReviews: true,
            hasTestimonials: false,
            mainTestimonial: {},
            isMainTestimonialSet: false,
            showMoreTestimonialsButton : false
        }
        this.fetchData = this.fetchData.bind(this)
    }
    
    componentDidMount() {
        this.fetchData()    
    }

    
    async fetchData() {
        await axiosWC.get(`/courses/${this.props.courseSlug}/testimonials/?page=1`, { 

        }).then(res => {
            if (res.data.testimonials.results){
                this.setState({
                    comments : res.data.testimonials.results,
                    mainTestimonial : res.data.testimonials.main_testimonial,
                    showMoreTestimonialsButton : res.data.testimonials.show_more_testimonials_button
                })
               let testimonials = []
               if(res.data.testimonials.main_testimonial && res.data.testimonials.results.length > 0){
                 testimonials.push(res.data.testimonials.main_testimonial)
                 testimonials.push(...res.data.testimonials.results)
                 this.props.setTestimonials({
                    data:testimonials,
                    showMoreTestimonials:res.data.testimonials.show_more_testimonials_button
                 })
              }
            }
        }).catch((err) => {

        })
    }

    render() {
        if (!this.state.mainTestimonial || !this.state.comments || !this.state.comments.length)
            return <div></div>
        return (
            <section className = "reviews">
                <h2 className = "d-block d-sm-none font-weight-bold text-dark mb-3">Reviews and Ratings</h2>
                <div className = "row review-section">
                    <div className = "col-md-6 col-12 fix-height pl-0 pr-0">
                        <div className = "h-100 bg-dark text-white alignReview">
                            {this.state.mainTestimonial && 
                                <div className = "col-11 col-sm-10 mx-auto topComment alignReviewSection">
                                    <div className = "mx-auto mb-2">
                                        <img alt = "" className = "img-fluid d-none d-sm-block reviewsImage rounded" src = {this.state.mainTestimonial.img_url}></img>
                                        <img alt = "" className = "img-fluid d-block d-sm-none reviewsImage rounded mt-3" src = {this.state.mainTestimonial.img_url}></img>
                                    </div>
                                    <div className="h4 sofia-pro" dangerouslySetInnerHTML={{ __html: this.state.mainTestimonial.handle }}></div>
                                    <div className="text-success sofia-pro" dangerouslySetInnerHTML={{ __html: this.state.mainTestimonial.achievements }}></div>
                                    <div className="urw-din left-review-content" dangerouslySetInnerHTML={{ __html: this.state.mainTestimonial.modified_data }}></div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className = "col-md-6 col-12">
                        <div className = "row">
                            <h2 className = "col-12 col-md-10 mx-auto d-none d-sm-block font-weight-bold text-left heading">Reviews and Ratings</h2>
                            <div className = "col-12 col-md-10 mx-auto">
                                {
                                    this.state.comments.map((comment, index) => {
                                        return (
                                            <div className="shadow-sm card mt-3 setReviewCardBorder" key = {index}>
                                                <div className = "row pl-3 pr-0 pt-2">
                                                    <div className = "col-3 col-sm-2 alignNameDesig">
                                                        <img className = "rounded-circle img-fluid testimonial-image" src = {comment.img_url}></img>        
                                                    </div>
                                                    <div className = "text-left alignNameDesig col-9 col-sm-10 pl-0">
                                                        <div className="h5 sofia-pro mb-1 heading" dangerouslySetInnerHTML={{ __html: comment.handle }}></div>
                                                        <div className="text-success sofia-pro left-review-content" dangerouslySetInnerHTML={{ __html: comment.achievements }}></div>
                                                    </div>
                                                </div>
                                                <div className="card-body pt-3">
                                                    <div className="card-text text-left text-muted urw-din reviews-content" dangerouslySetInnerHTML={{ __html: comment.modified_data }}></div>
                                                </div>
                                            </div> 
                                        )                   
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showMoreTestimonialsButton &&
                    <> 
                        <button data-toggle = "modal" onClick = {() => {
                            this.props.showtestimonialModal()
                       }}
                        data-target = "#feedbackModal" className = "btn sofia-pro font-weight-bold btn-lg btn-secondary mt-5"
                        id='view_testimonials'>View More Testimonials</button>
                    </>
                }
            </section>
        );
    }
}

export default withRouter(ReviewsComponent);
